import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "content"]

  connect() {
    this.modal = new Modal(this.modalTarget)
  }

  async add(event) {
    const eventId = event.currentTarget.dataset.eventId

    await this.load(`/guardians/new?event_id=${eventId}`)
  }

  async edit(event) {
    const guardianId = event.currentTarget.dataset.guardianId

    await this.load(`/guardians/${guardianId}/edit`)
  }

  async load(url) {
    this.contentTarget.innerHTML = `
      <div class="text-center py-4">
        Loading...
      </div>
    `

    this.modal.show()

    const response = await fetch(url, {
      headers: {
        "Accept": "text/html"
      }
    })

    if (!response.ok) {
      throw new Error("Failed to load modal")
    }

    this.contentTarget.innerHTML = await response.text()
  }
}